import randomElement from "../utility/randomElement";

function SelectV3(config, state, history){

	let tasks = config.minigames.map(mg => mg.name);


    let availableMinigame = randomElement(filterByConstraints(dropFinished(tasks, history), config, history));
			
	return availableMinigame;
}

function filterByConstraints(tasks, { constraints }, history) {
	var possibleTasks = []; // array of tasks satisfying 'order' constraints
	var priorTasks = []; // see `return` statement
	mgl: for (let task of tasks) {
		for (let [ type, mg1, mg2 ] of constraints) {
			switch (type) {
				case "order":
					if (mg2 !== task) continue;
					const hnames = history.map(({ minigame: { name } }) => name);
					if (mg2 === task && hnames.every(name => name !== mg1)) {
						continue mgl;
					}
					break;
				case "right after":
					var last = history[history.length - 1];
					if (mg2 === task && mg1 === last) {
						priorTasks.push(task);
						continue mgl;
					}
				case "never":
					if (task === mg1)  {
						continue mgl;
					}
					break;
				default:
					console.warn(`Unsupporting constraint type '${type}'`);
			}
		}
		possibleTasks.push(task);
	}
	return priorTasks.length ? priorTasks : possibleTasks;
}

function dropFinished(tasks, history) {
	const finished = finishedMinigames(history);
	return tasks.filter(name => !finished.includes(name));
}
function finishedMinigames(history) {
	return history.filter(({ finished }) => finished).map(({ minigame: { name } }) => name);
}

export default SelectV3;

